module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homePage"
  }, [_c('div', {
    staticClass: "hdfix",
    class: {
      hd2: _vm.topMsg.v
    }
  }, [_c('div', {
    staticClass: "header"
  }, [(_vm.mhDbShHotel) ? [_c('span', {
    on: {
      "click": _vm.goSearch
    }
  }, [_vm._v(_vm._s(_vm.homeUserInfo.hotelName)), _c('i', {
    staticClass: "iconfont icon-xia"
  })])] : [_c('span', [_vm._v(_vm._s(_vm.homeUserInfo.hotelName))])], _vm._v(" "), _c('div', {
    staticClass: "right",
    on: {
      "click": _vm.getbarcode
    }
  }, [_c('i', {
    staticClass: "iconfont icon-saoma"
  })]), _vm._v(" "), (_vm.topMsg.v) ? _c('div', {
    staticClass: "topMsg"
  }, [(_vm.topMsg.url && _vm.topMsg.url.indexOf('http') == 0) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openUrl(_vm.topMsg.url)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("flength")(_vm.topMsg.msg)) + "\n        ")]) : (_vm.topMsg.url) ? _c('router-link', {
    attrs: {
      "to": _vm.topMsg.url
    }
  }, [_vm._v(_vm._s(_vm._f("flength")(_vm.topMsg.msg)) + ">>\n        ")]) : [_vm._v(_vm._s(_vm._f("flength")(_vm.topMsg.msg)))], _vm._v(" "), _c('div', {
    staticClass: "cleartext",
    on: {
      "click": _vm.closeTopMsg
    }
  }, [_c('i', {
    staticClass: "iconfont icon-cuowu"
  })])], 2) : _vm._e()], 2)]), _vm._v(" "), _c('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "top-method": _vm.loadTop,
      "topDistance": 50,
      "maxDistance": 130,
      "top-status": _vm.topStatus
    },
    on: {
      "top-status-change": _vm.handleTopChange,
      "update:topStatus": function($event) {
        _vm.topStatus = $event
      },
      "update:top-status": function($event) {
        _vm.topStatus = $event
      }
    }
  }, [_c('div', {
    staticClass: "myList"
  }, [_c('my-list')], 1), _vm._v(" "), (_vm.mhDbReven) ? [_c('div', {
    class: {
      'isLiCheng': !_vm.isLiCheng
    }
  }, [_c('lichengHomeData', {
    ref: "lichengHomeData"
  })], 1), _vm._v(" "), _c('div', {
    class: {
      'isLiCheng': _vm.isLiCheng
    }
  }, [_c('homeData', {
    ref: "homeData"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mint-loadmore-top",
    attrs: {
      "slot": "top"
    },
    slot: "top"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.topStatus !== 'loading'),
      expression: "topStatus !== 'loading'"
    }],
    class: {
      'rotate': _vm.topStatus === 'drop'
    }
  }, [_vm._v(" ↓ " + _vm._s(_vm.$t('index_refresh')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.topStatus === 'loading'),
      expression: "topStatus === 'loading'"
    }]
  }, [_vm._v("Loading...")])])] : _vm._e()], 2), _vm._v(" "), _c('foot-nav', {
    attrs: {
      "sta": "1"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-5a88cc72","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/page/index.vue
// module id = 1792
// module chunks = 107